import { FunctionComponent, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

import useDrawerPortalNode from '@hooks/useDrawerPortalNode'

import DrawerContainer from './DrawerContainer'
import useBodyScroll from '@hooks/useBodyScroll'

export interface DrawerPortalProps {
  open?: boolean
  children: React.ReactNode
  onClose: () => void
  direction?: 'left' | 'right'
}

const DrawerPortal: FunctionComponent<DrawerPortalProps> = ({
  direction = 'left',
  open = true,
  onClose,
  children,
}) => {
  const drawerPortalNode = useDrawerPortalNode()
  const isBodyScrollLocked = useRef(false)

  const { lockBodyScroll, unlockBodyScroll } = useBodyScroll()

  useEffect(() => {
    if (open) {
      isBodyScrollLocked.current = true
      lockBodyScroll()
    } else {
      isBodyScrollLocked.current = false
      unlockBodyScroll()
    }

    return () => {
      if (isBodyScrollLocked.current) {
        unlockBodyScroll()
      }
    }
  }, [open, lockBodyScroll, unlockBodyScroll])

  return drawerPortalNode
    ? createPortal(
        <DrawerContainer direction={direction} open={open} onClose={onClose}>
          {children}
        </DrawerContainer>,
        drawerPortalNode
      )
    : null
}

export default DrawerPortal
